module.exports = "<p>\n  Error! You took the wrong turn.\n</p>\n"